<script lang=ts>
      import { onMount } from "svelte"
      import Print from "../debug/Print.svelte"
      import Sizes from "../debug/Sizes.svelte"
      import { createDebugContext } from "./ts/Debug.svelte"
      import { CacheContext } from "$lib/utils/cache"

  const debug = createDebugContext()

  onMount( () => {
    window._caches = new CacheContext()
  })

  let { children = null } = $props()
</script>

{#if debug.enabled}
<!--<Sizes></Sizes>-->
<!--<Print></Print>-->
{/if}
{@render children?.() }